import axios from 'axios'

export default class Eventservice {
  getAll() {
    return axios.get('api/events/all')
  }

  getById(id) {
    return axios.get('api/events/' + id)
  }

  create(event) {
    return axios.post('api/events/create/', event)
  }

  update(event) {
    return axios.put('api/events/update/', event)
  }

  delete(id) {
    return axios.delete('api/events/delete/' + id)
  }
}
